import React, { useEffect, useRef, useState } from "react";
import { HomeHeader } from "../../../components/headers/HomeHeader";

const HOME_HEADER_HEIGHT = 79; // adjust to your HomeHeader height

export const LargeLossAlerts = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const tagRef = useRef(null);
  const menuRef = useRef(null);
  const year = new Date().getFullYear();

  useEffect(() => {
    const onClickAway = (e) => {
      if (!menuOpen) return;
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        tagRef.current &&
        !tagRef.current.contains(e.target)
      ) {
        setMenuOpen(false);
      }
    };
    window.addEventListener("click", onClickAway);
    return () => window.removeEventListener("click", onClickAway);
  }, [menuOpen]);

  return (
    <div>
      <HomeHeader headerColor={"#0D131E"} textColor={"#ffffff"} />

      {/* Scoped page styles (no global bleed) */}
      <style>{`
        li {
          padding-top:10px;
          padding-bottom:0px;
        }
        .lla-root {
          --bg:#0a0c10; --panel:#0f131a; --panel-2:#121722; --text:#e6e9ef;
          --muted:#a7b0c0; --brand:#0b5cff; --brand-2:#8ab4ff;
          --ok:#1fbf75; --warn:#ffd166; --danger:#ff5d5d;
          --card-radius:18px; --shadow:0 10px 30px rgba(0,0,0,.35);
          --maxw:1100px; --offset:${HOME_HEADER_HEIGHT}px;

          color:var(--text);
          background:
            radial-gradient(1200px 800px at 10% -10%, rgba(11,92,255,.15), transparent 60%),
            radial-gradient(1200px 800px at 110% 10%, rgba(138,180,255,.1), transparent 60%),
            var(--bg);
          line-height:1.55;
          font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji";
          text-align:left;
          letter-spacing: normal;
        }
        .lla-container { max-width:var(--maxw); margin:0 auto; padding:24px; }

        /* Sticky page header (sits below HomeHeader) */
        .lla-header {
          position: sticky;
          top: var(--offset);
          z-index: 50;
          backdrop-filter: saturate(140%) blur(10px);
          background: linear-gradient(180deg, rgba(10,12,16,.9), rgba(10,12,16,.6));
          border-bottom: 1px solid rgba(255,255,255,.06);
        }
        .lla-nav { display:flex; align-items:center; justify-content:space-between; gap:16px; }
        .lla-logo { display:flex; align-items:center; gap:12px; text-decoration:none; color:var(--text); }
        .lla-mark { width:28px; height:28px; display:grid; place-items:center; border-radius:8px; background:linear-gradient(135deg, var(--brand), #2b90ff); box-shadow:var(--shadow); }
        .lla-word { font-weight:700; letter-spacing:.2px; }

        .lla-cta { display:flex; gap:10px; }
        .lla-btn {
          --padx:14px; --pady:10px;
          padding:var(--pady) var(--padx);
          border-radius:999px;
          border:1px solid rgba(255,255,255,.12);
          color:var(--text);
          text-decoration:none;
          font-weight:600; font-size:14px;
          transition: transform .06s ease, background .2s ease, border-color .2s ease;
        }
        .lla-btn:hover { transform: translateY(-1px); }
        .lla-btn.primary { background: linear-gradient(135deg, var(--brand), #2b90ff); border-color: transparent; }
        .lla-btn.ghost { background: rgba(255,255,255,.03); }

        .lla-hero { padding:56px 0 26px; position: relative; }
        .lla-hero h1 { font-size: clamp(34px, 3.8vw, 48px); line-height:1.12; margin:0 0 16px; letter-spacing:.3px; word-spacing:.4px; }
        .lla-hero p { color:var(--muted); font-size:clamp(16px, 1.7vw, 18px); max-width:880px; }
        .lla-tag {
          display:inline-flex; align-items:center; gap:8px; padding:6px 12px;
          border-radius:999px; background:rgba(11,92,255,.12);
          color:#cfe0ff; border:1px solid rgba(138,180,255,.25);
          font-weight:600; font-size:13px; cursor:pointer;
        }

        .lla-grid { display:grid; gap:18px; }
        .lla-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
        .lla-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        @media (max-width: 900px){ .lla-cols-3, .lla-cols-2 { grid-template-columns: 1fr; } }

        .lla-card { background: linear-gradient(180deg, var(--panel), var(--panel-2)); border:1px solid rgba(255,255,255,.06); border-radius:var(--card-radius); box-shadow:var(--shadow); padding:20px 18px; }
        .lla-card h3 { margin:0 0 8px; font-size:18px; }
        .lla-card p { margin:0; color:var(--muted); }

        .lla-kv { display:flex; gap:12px; align-items:flex-start; padding:14px 0; border-top:1px dashed rgba(255,255,255,.08); }
        .lla-kv:first-child { border-top:0; }
        .lla-k { flex:0 0 140px; color:#cfe0ff; font-weight:700; text-transform:uppercase; letter-spacing:.6px; font-size:12px; }
        .lla-v { flex:1; color:var(--text); }

        .lla-badges { display:flex; gap:8px; flex-wrap:wrap; }
        .lla-badge { display:inline-flex; align-items:center; gap:8px; padding:8px 12px; border-radius:12px; background:rgba(255,255,255,.04); border:1px solid rgba(255,255,255,.08); font-weight:600; color:var(--text); }
        .lla-muted { color:var(--muted); }

        .lla-section { margin:30px 0; }
        .lla-section h2 { font-size:22px; margin:0 0 8px; }

        .lla-headline { display:flex; align-items:center; gap:12px; margin:28px 0 10px; }
        .lla-rule { height:1px; background:linear-gradient(90deg, rgba(255,255,255,0), rgba(255,255,255,.2), rgba(255,255,255,0)); flex:1; }

        .lla-callout { border-left:3px solid var(--brand); background:rgba(11,92,255,.08); padding:14px 16px; border-radius:10px; }

        .lla-footer { margin:40px 0 20px; color:var(--muted); font-size:13px; text-align:center; }

        /* Dropdown */
        .lla-menu {
          position:absolute; background-color:#0f131a; min-width:260px; z-index:10;
          border-radius:10px; box-shadow:var(--shadow); border:1px solid rgba(255,255,255,.12);
          margin-top:8px;
        }
        .lla-menu a { color:var(--text); padding:12px; text-decoration:none; display:block; }
        .lla-menu a:hover { background-color: var(--brand-2); }

        @media print {
          .lla-header{ display:none; }
          .lla-root{ background:#fff; color:#111; }
          .lla-card{ background:#fff; border-color:#ddd; box-shadow:none; }
          .lla-hero .lla-tag{ background:#e9f1ff; color:#0b5cff; border-color:#c9ddff; }
        }
      `}</style>

      <div className="lla-root">
        {/* Page header under HomeHeader */}
        <header className="lla-header">
          <div className="lla-container lla-nav">
            <a
              className="lla-logo"
              href="#top"
              aria-label="Charlee.ai — Large Loss Alerts"
            >
              <span className="lla-mark" aria-hidden="true">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path
                    d="M12 2l2.2 5.7L20 10l-5.8 2.3L12 18l-2.2-5.7L4 10l5.8-2.3L12 2z"
                    fill="white"
                    opacity=".9"
                  />
                </svg>
              </span>
              <span className="lla-word">Charlee.ai</span>
            </a>
            <div className="lla-cta">
              <a className="lla-btn ghost" href="#value">
                Value
              </a>
              <a className="lla-btn ghost" href="#financial-impact">
                Financial Impact
              </a>
              <a className="lla-btn primary" href="#product">
                Product
              </a>
            </div>
          </div>
        </header>

        <main className="lla-container" style={{ paddingTop: "70px" }}>
          <section className="lla-hero">
            {/* Dropdown trigger */}
            <span
              ref={tagRef}
              id="useCaseDropdown"
              className="lla-tag"
              onClick={() => setMenuOpen((v) => !v)}
              aria-haspopup="true"
              aria-expanded={menuOpen}
              role="button"
            >
              Use Case 1 · Large Loss Alerts <span aria-hidden="true">▼</span>
            </span>

            {/* Dropdown menu (use your app routes for SPA + SEO-friendly anchors) */}
            <div
              ref={menuRef}
              id="dropdownMenu"
              className="lla-menu"
              style={{ display: menuOpen ? "block" : "none" }}
            >
              <a href="/usecase/large-loss-alerts">
                Use Case 1 · Large Loss Alerts
              </a>
              <a href="/usecase/early-severity-signal-detection">
                Use Case 2 · Early Severity Signal Detection
              </a>
              <a href="/usecase/reserve-adequacy-monitoring">
                Use Case 3 · Reserve Adequacy Monitoring (Incurred Below
                Prediction)
              </a>
              <a href="/usecase/high-severity-potential-claims">
                Use Case 4 · High Severity Potential Claims
              </a>
              <a href="/usecase/proactive-severity-litigation-intelligence">
                Use Case 5 · Proactive Severity & Litigation Intelligence
              </a>
              <a href="/usecase/intelligent-claims-document-summarization">
                Use Case 6 · Intelligent Claims Document Summarization
              </a>
            </div>

            <h1 style={{ fontWeight: "bold" }}>
              Flag and Prioritize Large-Loss Potential <br />— Early,
              Consistently, and With Context
            </h1>
            <p>
              Large loss claims typically involve high-severity injuries,
              extensive property damage, or significant liability exposures.
              These cases often contain vast amounts of data—much of it buried
              in unstructured sources like claim notes, documents, third-party
              reports, demand packages, and emails. During the First Notice of
              Loss (FNOL) process, critical details from these sources can be
              easily missed or overlooked. When left undetected, these gaps can
              delay escalation, lead to inaccurate reserving, and expose the
              insurer to significant financial and reputational risk.
            </p>
            <br />
            <p className="lla-muted">
              Charlee addresses this challenge by applying pre-trained learnings
              on large-loss indicators—continuously refined from across all
              customer claims. Its AI constantly monitors open and pending
              claims, scanning both structured and unstructured data for
              high-risk patterns. When a match is found, Charlee scores and
              prioritizes the claim, ensuring early attention and appropriate
              resource allocation.
            </p>
          </section>

          <section className="lla-grid lla-cols-3">
            <div className="lla-card">
              <h3 style={{ fontWeight: "bold" }}>Role</h3>
              <p>Claims Supervisor or Large Loss Team Lead, Claims Manager</p>
            </div>
            <div className="lla-card">
              <h3 style={{ fontWeight: "bold" }}>Job at Hand</h3>
              <p>
                Ensure early identification and proactive handling of
                high-severity claims
              </p>
            </div>
            <div className="lla-card">
              <h3 style={{ fontWeight: "bold" }}>Trigger</h3>
              <p>
                Catastrophes, fatalities, high-severity injuries, large
                exposures, and emerging risk patterns
              </p>
            </div>
          </section>

          <section className="lla-section">
            <div className="lla-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>Opportunity</h2>
              <div className="lla-rule" />
            </div>
            <div className="lla-card">
              <p>
                Timely identification of large-loss potential enables better
                triage, faster intervention, and improved outcomes for both the
                insurer and the claimant.
              </p>
            </div>
          </section>

          <section className="lla-grid lla-cols-2 lla-section">
            <div className="lla-card">
              <h3 style={{ fontWeight: "bold" }}>Before Charlee</h3>
              <p>
                Identification depended on manual review, adjuster notes, or
                keyword searches—which could miss signals if critical
                information wasn’t documented clearly at FNOL.
              </p>
            </div>
            <div className="lla-card">
              <h3 style={{ fontWeight: "bold" }}>With Charlee</h3>
              <p id="product">
                Charlee’s AI proactively analyzes narrative context, structured
                loss data, and historical patterns to flag potential large-loss
                claims early—even if terminology varies. This enables
                supervisors to intervene sooner, assign intelligently, and guide
                claims down the right path from the start.
              </p>
            </div>
          </section>

          <section className="lla-section">
            <div className="lla-grid lla-cols-3">
              <div className="lla-card">
                <h3 style={{ fontWeight: "bold" }}>Product Used</h3>
                <div className="lla-badges">
                  <span className="lla-badge" title="4SeeCharlee">
                    🔎 4SeeCharlee
                  </span>
                </div>
              </div>
              <div className="lla-card">
                <h3 style={{ fontWeight: "bold" }}>LOBs</h3>
                <div className="lla-badges">
                  <span className="lla-badge">All</span>
                </div>
              </div>
              <div className="lla-card" id="value">
                <h3 style={{ fontWeight: "bold" }}>Area</h3>
                <div className="lla-badges">
                  <span className="lla-badge">Claims</span>
                  <span className="lla-badge">FNOL</span>
                  <span className="lla-badge">Severity</span>
                </div>
              </div>
            </div>
          </section>

          <section className="lla-section">
            <div className="lla-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>
                Value Proposition
              </h2>
              <div className="lla-rule" />
            </div>
            <div className="lla-card">
              <ul style={{ listStyleType: "disc", paddingLeft: "50px" }}>
                <li>
                  Early red flags allow Claims Managers to prioritize files
                  without manual sifting.
                </li>
                <li>
                  Improved tech skills among early-stage adjusters reduce claim
                  transfers.
                </li>
                <li id="financial-impact">
                  Access to red flags at FNOL reduces file touches and redundant
                  reviews.
                </li>
                <li>
                  Boosts productivity, saves time on repetitive tasks, and
                  enhances data management.
                </li>
              </ul>
            </div>
          </section>

          <section className="lla-section">
            <div className="lla-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>
                Financial Impact
              </h2>
              <div className="lla-rule" />
            </div>
            <div className="lla-card">
              <p className="lla-muted">
                Undetected large-loss claims often result in:
              </p>
              <ul style={{ listStyleType: "disc", paddingLeft: "50px" }}>
                <li>
                  Delayed escalation, causing missed early negotiation windows
                </li>
                <li>
                  Inaccurate reserves, leading to regulatory scrutiny or capital
                  misallocation
                </li>
              </ul>
              <div className="lla-callout" style={{ marginTop: 12 }}>
                <strong>Why it matters:</strong> Early, AI-driven detection
                helps carriers avoid leakage, align reserves sooner, and focus
                expertise where it matters most.
              </div>
            </div>
          </section>

          <section className="lla-section">
            <div className="lla-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>
                How It Works (At a Glance)
              </h2>
              <div className="lla-rule" />
            </div>
            <div className="lla-card">
              <div className="lla-kv">
                <div className="lla-k">Signals</div>
                <div className="lla-v">
                  Patterns across claim notes, medical narratives, demand
                  packages, police/TPA reports, emails, and structured fields
                  (injury type, policy limits, venue, etc.).
                </div>
              </div>
              <div className="lla-kv">
                <div className="lla-k">Scoring</div>
                <div className="lla-v">
                  Risk scoring with explainable drivers for supervisor review
                  and routing.
                </div>
              </div>
              <div className="lla-kv">
                <div className="lla-k">Actioning</div>
                <div className="lla-v">
                  Queue prioritization, escalation prompts, and assignment
                  guidance to Large Loss teams.
                </div>
              </div>
            </div>
          </section>

          <footer className="lla-footer">
            © {year} Charlee.ai — Use Case 1: Large Loss Alerts
          </footer>
        </main>
      </div>
    </div>
  );
};
